import { ProductSummary } from "@/common/productSummary/types";
import { SearchResult } from "@/components/Search/types";
import { ProductCardProps } from "@/components/ProductCard/types";
import { getLevel } from "@/components/Search/utils/getLevel";
import getProductSummaryFlexibility from "@/lib/productSummary/helper/getProductSummaryFlexibility";

export function convertHitToProductCardProps(
  hit: ProductSummary | SearchResult,
  indexName: string,
  results?: { queryID?: string; index?: string },
): ProductCardProps {
  if (indexName === "product") {
    const searchResult = hit as SearchResult;
    return {
      name: searchResult.title,
      href: searchResult.marketing_url.replace(
        /^https?:\/\/(www\.)?edx\.org/,
        "",
      ),
      imageUrl: searchResult.card_image_url || "",
      type: searchResult.learning_type?.[0],
      programType: searchResult.program_type as string[],
      partnerKey: searchResult.partner_keys,
      partnerFullName: searchResult.partner,
      partnerLogoUrl: searchResult.owners?.[0]?.logoImageUrl || "",
      subjects: searchResult.subject?.at(0),
      index: searchResult.__position ? searchResult.__position - 1 : 0,
      objectId: searchResult.objectID,
      queryId: results?.queryID,
      productSource: searchResult.product_source || undefined,
      product: searchResult.product,
      uuid: searchResult.uuid,
      parentTitle: searchResult.title,
      activeRunKey: searchResult.active_run_key,
      resultsIndex: results?.index,
      organizationLogoOverride:
        searchResult.organization_logo_override || undefined,
      weeksToComplete: searchResult.weeks_to_complete || undefined,
      level: getLevel(searchResult.level?.[0] ?? ""),
      childCoursesCount: searchResult.course_titles?.length || undefined,
      pacing: undefined,
      hoverOverlay: {
        primaryDescription: searchResult.primary_description || "",
        aboutThisProduct: searchResult.secondary_description || "",
        learningBulletItems: searchResult.tertiary_description || "",
        skillsList: searchResult.skills?.map((skill) => skill.skill) || [],
      },
    };
  } else {
    const productSummary = hit as ProductSummary;
    return {
      name: productSummary.productName,
      href: productSummary.productSlug.replace(
        /^https?:\/\/(www\.)?edx\.org/,
        "",
      ),
      imageUrl: productSummary.productImageUrl || "",
      type: productSummary.productType,
      programType: [productSummary.productType],
      partnerKey: productSummary.partnerKeys,
      partnerFullName: productSummary.partnerName,
      partnerLogoUrl: productSummary.partnerLogoUrl,
      subjects: productSummary.attributes?.at(0),
      index: productSummary.__position ? productSummary.__position - 1 : 0,
      objectId: productSummary.objectID,
      queryId: results?.queryID,
      productSource: productSummary.productSource || undefined,
      product: productSummary.product,
      uuid: productSummary.productUuid,
      parentTitle: productSummary.productName,
      activeRunKey: productSummary.activeRunKey,
      resultsIndex: results?.index,
      organizationLogoOverride: productSummary.partnerLogoOverride || undefined,
      weeksToComplete: productSummary.weeksToComplete || undefined,
      level: getLevel(productSummary.level ?? ""),
      childCoursesCount: productSummary.courseCount ?? undefined,
      pacing: getProductSummaryFlexibility(productSummary.flexibility) as
        | "self_paced"
        | "instructor_paced"
        | undefined,
      hoverOverlay: {
        primaryDescription: productSummary.productOverview || "",
        aboutThisProduct: productSummary.fullDescription || "",
        learningBulletItems: productSummary.shortDescription || "",
        skillsList:
          productSummary.skillsData?.map((skill) => skill.skill) || [],
      },
    };
  }
}
